export default __webpack_public_path__ + "static/media/ogadonate-img.fb3f7cc0.png";